import React from 'react';
import Dialog from 'common/mdc/dialog';
import { node, number, string } from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';

const messages = defineMessages({
  cancelChangesTitle: {
    id: 'job.cancel.static.dialogs.canel-changes',
    defaultMessage: 'Cancel job',
  },
  deletingFile: {
    id: 'job.dialogs.deletingFile',
    defaultMessage: '{jobId} will be cancelled',
  },
});

const DeletingDialog = ({ buttons, jobId, intl }) => (
  <Dialog
    title={intl.formatMessage(messages.cancelChangesTitle)}
    buttons={buttons}
  >
    <FormattedMessage {...messages.deletingFile} values={{ jobId }} />
  </Dialog>
);

DeletingDialog.propTypes = {
  buttons: node,
  jobId: number,
  intl: intlShape.isRequired,
};

DeletingDialog.defaultProps = {
  buttons: undefined,
  jobId: '',
};

export default injectIntl(DeletingDialog);
